// for payroll history  of employee
export const RESER_GET_PAYMENT_DETAILS = "resign_get_payment_details";
export const GET_PAYMENT_DETAILS = "get_payment_details";
export const GET_PAYMENT_DETAILS_SUCCESS = "get_payment_details_success";
export const GET_PAYMENT_DETAILS_FAILURE = "get_payment_details_failure";
